// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMDialog.tsx — PropelMapper standardized center dialog.
//
// Scrim rgba(0,0,0,0.5) + centered white card (maxWidth 400, radius 16) that
// fades/scales in. Use for short, focused decisions and small forms where a
// bottom sheet is overkill (confirm/discard, rename, add-feature). For longer,
// scrollable forms prefer PMSheet.
//
// Composes an icon+title header with close, a scrollable body, and an optional
// footer (pass a <PMFormActions/>). Renders absolutely inside its positioned
// ancestor. Pass open={false} to unmount.

function pmEnsureOverlayKeyframesD() {
  if (typeof document === "undefined") return;
  if (document.getElementById("pm-overlay-kf")) return;
  const el = document.createElement("style");
  el.id = "pm-overlay-kf";
  el.textContent =
    "@keyframes pmScrimIn{from{opacity:0}to{opacity:1}}" +
    "@keyframes pmSheetUp{from{transform:translateY(100%)}to{transform:translateY(0)}}" +
    "@keyframes pmDialogIn{from{opacity:0;transform:scale(.96) translateY(8px)}to{opacity:1;transform:none}}" +
    "@media (prefers-reduced-motion: reduce){" +
    ".pm-anim-scrim,.pm-anim-sheet,.pm-anim-dialog{animation:none!important}}";
  document.head.appendChild(el);
}

function PMDialogCloseGlyph({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function PMDialog({
  open = true,
  title,
  subtitle,
  titleIcon = null,
  onClose,
  children,
  footer = null,
  maxWidth = 400,
  dismissOnScrim = true,
  showClose = true,
  zIndex = 70,
  style = {},
}: any) {
  pmEnsureOverlayKeyframesD();
  if (open === false) return null;

  return (
    <div
      className="pm-anim-scrim"
      onClick={dismissOnScrim ? onClose : undefined}
      style={{
        position: "absolute",
        inset: 0,
        zIndex,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        animation: "pmScrimIn 180ms ease",
        fontFamily: "var(--pm-font-sans)",
      }}
    >
      <div
        className="pm-anim-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={title || "Dialog"}
        onClick={(e: any) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth,
          maxHeight: "90%",
          background: "var(--pm-surface)",
          borderRadius: "var(--pm-radius-xl)",
          display: "flex",
          flexDirection: "column",
          boxShadow: "var(--pm-shadow-xl)",
          animation: "pmDialogIn 220ms cubic-bezier(0.32,0.72,0,1)",
          ...style,
        }}
      >
        {/* Header */}
        {(title || showClose) && (
          <div style={{ display: "flex", alignItems: "flex-start", gap: 12, padding: "20px 20px 0" }}>
            {titleIcon && <span style={{ flexShrink: 0, display: "inline-flex", marginTop: 1 }}>{titleIcon}</span>}
            <div style={{ flex: 1, minWidth: 0 }}>
              {title && (
                <div style={{ font: "700 20px/1.25 var(--pm-font-sans)", color: "var(--pm-fg-1)", letterSpacing: "-0.2px" }}>
                  {title}
                </div>
              )}
              {subtitle && (
                <div style={{ marginTop: 4, font: "400 13px/1.45 var(--pm-font-sans)", color: "var(--pm-fg-3)" }}>
                  {subtitle}
                </div>
              )}
            </div>
            {showClose && (
              <button
                onClick={onClose}
                aria-label="Close"
                style={{
                  flexShrink: 0,
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 4,
                  margin: -4,
                  display: "flex",
                  color: "var(--pm-fg-2)",
                }}
              >
                <PMDialogCloseGlyph />
              </button>
            )}
          </div>
        )}

        {/* Body */}
        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: 20, display: "flex", flexDirection: "column", gap: 14 }}>
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div style={{ padding: 16, borderTop: "1px solid var(--pm-border-light)" }}>{footer}</div>
        )}
      </div>
    </div>
  );
}
